import { render, staticRenderFns } from "./ResourceNotFound.vue?vue&type=template&id=1332e05a&scoped=true"
import script from "./ResourceNotFound.vue?vue&type=script&lang=js"
export * from "./ResourceNotFound.vue?vue&type=script&lang=js"
import style0 from "./ResourceNotFound.vue?vue&type=style&index=0&id=1332e05a&prod&lang=css"
import style1 from "./ResourceNotFound.vue?vue&type=style&index=1&id=1332e05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1332e05a",
  null
  
)

export default component.exports